import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-code-s-slash-line',
      title: 'Web Design & Development',
      description: 'Beautiful, fast, and functional websites that convert visitors into customers. From landing pages to complex web apps.',
      color: 'from-[#D96B33] to-[#D96B33]/80',
      hasLearnMore: true,
      learnMoreLink: '/web-design-development'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Automation & AI Integrations',
      description: 'Let technology do the heavy lifting. We build smart workflows and AI-powered tools that save time and boost productivity.',
      color: 'from-[#AFC4E4] to-[#AFC4E4]/80',
      hasLearnMore: true,
      learnMoreLink: '/automation-ai-integrations'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'QA & Testing Services',
      description: 'Bulletproof your product. Comprehensive testing to catch bugs before your users do, ensuring flawless performance.',
      color: 'from-[#2E3F25] to-[#2E3F25]/80',
      hasLearnMore: true,
      learnMoreLink: '/qa-testing-services'
    },
    {
      icon: 'ri-palette-line',
      title: 'Branding & Digital Strategy',
      description: 'Stand out from the crowd. Strategic branding and digital presence that tells your story and connects with your audience.',
      color: 'from-[#D96B33] to-[#AFC4E4]',
      hasLearnMore: true,
      learnMoreLink: '/branding-digital-strategy'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#EBEBE0] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            What We <span className="text-[#D96B33]">Do</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-3xl mx-auto" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            We're your full-stack creative tech partner. Here's how we help you win:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white p-10 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer hover:-translate-y-1"
            >
              {/* Gradient background on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              
              <div className="relative z-10">
                <div className={`w-20 h-20 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
                  <i className={`${service.icon} text-4xl text-white`}></i>
                </div>
                
                <h3 className="text-3xl font-bold text-[#182114] mb-4" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                  {service.title}
                </h3>
                
                <p className="text-lg text-[#2E3F25] leading-relaxed mb-6" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                  {service.description}
                </p>

                {service.hasLearnMore && (
                  <Link 
                    to={service.learnMoreLink}
                    className="inline-flex items-center gap-2 text-[#D96B33] font-semibold hover:text-[#B85A2B] transition-colors duration-300 whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: '"Century Gothic", sans-serif' }}
                  >
                    Learn More 
                    <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
